import { camelCase, lowerCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import {
  compareWithAtom,
  groupByAtom,
  selectedCategoriesAtom,
  selectedFunctionsAtom
} from '../../atoms';

import { Chip } from '@mui/material';

import {
  SettingsChipContainer,
  SettingsPopper,
  StyledSettingsSection
} from 'components/shared/Settings';

import Settings from './Settings';

export default function SettingsSection() {
  const { t } = useTranslation('common');
  const [groupBy, setGroupBy] = useRecoilState(groupByAtom);
  const [selectedCategories, setSelectedCategories] = useRecoilState(
    selectedCategoriesAtom
  );
  const [compareWith, setCompareWith] = useRecoilState(compareWithAtom);
  const [selectedFunctions, setSelectedFunctions] = useRecoilState(
    selectedFunctionsAtom
  );
  return (
    <StyledSettingsSection>
      <SettingsChipContainer>
        {groupBy && (
          <Chip
            size="small"
            label={`${t('groupBy')}: ${t(groupBy)}`}
            onDelete={() => setGroupBy('')}
          />
        )}
        {selectedCategories.map(({ id: cId, name }) => {
          const prefix = 'dhtCategories.';
          const translatableName = camelCase(
            lowerCase(name.replaceAll('_', ' '))
          );
          const label =
            name === t('unknown')
              ? t('unknown')
              : t(`${prefix}${translatableName}`);

          return (
            <Chip
              size="small"
              key={cId}
              label={`${t('category')}: ${label}`}
              onDelete={() =>
                setSelectedCategories(
                  selectedCategories.filter(({ id }) => id !== cId)
                )
              }
            />
          );
        })}
        {selectedFunctions.map(({ id: fId, name }) => (
          <Chip
            size="small"
            key={fId}
            label={`${t('function')}: ${name}`}
            onDelete={() =>
              setSelectedFunctions(
                selectedFunctions.filter(({ id }) => id !== fId)
              )
            }
          />
        ))}
        {compareWith && (
          <Chip
            size="small"
            label={`${t('compareWith')}: ${t(
              `analyzer.filters.${camelCase(lowerCase(compareWith))}`
            )}`}
            onDelete={() => setCompareWith('')}
          />
        )}
      </SettingsChipContainer>
      <SettingsPopper>
        <Settings />
      </SettingsPopper>
    </StyledSettingsSection>
  );
}
